import _ from "lodash";
import QueryJobtitles from "graphql/queries/QueryJobtitles";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchJobtitle
{
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'jobtitles', QueryJobtitles, {
			variables,
			resultPath: [ 'jobtitles' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						jobtitles: result
					});
				}
			}
		})
	}
}
